<mat-form-field class="w-100">
	<input
		[textMask]="phoneMask"
		autocomplete="off"
		matInput
		placeholder="Primary Phone Number"
		[formControl]="phoneNumberInput"
	/>
	<mat-error *ngIf="phoneNumberInput.hasError('badPhoneNumber')"
		>Invalid phone number format</mat-error
	>
</mat-form-field>
